export enum CheckStep {
  Initial = 'Initial',
  FillLateReport = 'FillLateReport',
  TaskContents = 'TaskContents',
  TasksWizard = 'TasksWizard'
}
